// https://www.color-name.com/hex/820A0A
export const COLORS = {
  purple: "#C125AD",
  hovered_purple: "#E02AC8",
  white: "#FFFFFF",
  whites: {
    50: "rgba(255, 255, 255, 0.5)",
    75: "rgba(255, 255, 255, 0.75)",
  },
  grey: "#E1E1E1",
  grayShade: "#00000099",
  // many darks with opacity
  gray: {
    0: "#0000001f",
    1: "#979797",
    2: "#909090",
    3: "#E6E9EC",
  },
  darks: {
    0: {
      100: "#212121",
      1: "#21212100",
      3: "#21212108",
      4: "#2121210A",
      6: "#2121210F",
      10: "#2121211A",
      15: "#21212126",
      25: "#21212140",
      50: "#21212180",
      60: "#15151599",
      70: "#212121b3",
    },
    1: "#858585",
    2: "#C0BFC0",
    3: "#E6E6E6",
    4: "#F0F0F0",
    5: "#EDEDED",
    6: "#EEEEEE",
    7: "#F2F2F2",
    8: "#EAEAF0",
    9: "#EAE9ED40",
  },
  // color purple with opacity
  purples: {
    0: "#C125AD",
    10: "#C125AD1A",
    20: "#C125AD33",
    50: "#C125AD80",
  },
  red: "#FF0000",
  silver: "#CCCCCC",
  cultured: "#F8F8F8",
  newCultured: "#F3F7FA",
  green: "#45941E",
  lightGreen: "#E7FCDC",
  orange: "#E9972D",
  lightOrange: "#FCF3D9",
  blue: "#256EFF",
  blueShine: "#4094F7",
  bluePalatinate: "#2329D6",
  lightBlues: {
    0: {
      100: "#5B8FFF",
      6: "#5b8fff0f",
    },
  },
  black: "#000000",
  blacks: {
    10: "rgba(0, 0, 0, 0.1)",
  },
  offwhite: {
    25: "rgba(0, 0, 0, 0.25)",
  },
  yellow: "#FB941C",
  cian: "#6EC1CB",
  lightYellow: "#FFC905",
  viking: "#5DBDDC",
  barnRed: "#820A0A",
  internationalOrange: "#C00C0C",
  lightCarminePink: "#E66262",
  maize: "#EBC346",
  dollarBill: "#86C667",
  spanishGray: "#9B9B9B",
  blueMagenta: "#784af4",
  deepPeach: {
    0: {
      100: "#FFC9A7",
      2: "#ffc9a733",
    },
  },
  rebeccaPurple: "#673898",
  davisGrey: "#585858",
  lightPink: "#FFE6E6",
  silverSand: {
    100: "#C4C4C4",
    50: "#C4C4C480",
  },
  americanSilver: "#D0D0D0",
  mikadoYellow: "#FFC10B",
  majorelleBlue: "#5837E4",
  verdigris: "#3BAAB1",
  pearlyPurple: "#B96793",
  shadowBlue: "#7E82AD",
  olivine: "#90B67D",
  crayola: "#CE8464",
  purpleGrey: "#5F6388",
  purpleDark: "#140028",
  greyDark: "#C7C7C7",
  greenLogo: "#65FFCD",
  greyLight: "#E1E3E8",
  russianViolet: "#351D4E",
  antiFlashWhite: "#F0F1F3",
};
